import ChartIcon from './ChartIcon';

export default ChartIcon;
